import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCcVisa, faCcAmex, faCcMastercard, faCcPaypal, faApplePay, faGooglePay } from "@fortawesome/free-brands-svg-icons";

import faKlarna from "../assets/images/klarna.svg";
import faClearpay from "../assets/images/clearpay.svg";

import Config from "../Config";

import SVG from "react-inlinesvg";

import "../assets/scss/components/_payment-types.scss";

export const PaymentTypes = () => {
	const { paymentMethodsEnabled } = Config;

	return (
		<div className="payment-card-types">
			<FontAwesomeIcon
				icon={faCcVisa}
				color="#2340E8"
			/>
			<FontAwesomeIcon
				icon={faCcAmex}
				color="#1E74D0"
			/>
			<div className="mastercard-wrapper">
				<FontAwesomeIcon icon={faCcMastercard} />
			</div>
			{paymentMethodsEnabled?.paypalEnabled && (
				<FontAwesomeIcon
					icon={faCcPaypal}
					color="#0F388B"
				/>
			)}
			{paymentMethodsEnabled?.applePayEnabled && <FontAwesomeIcon icon={faApplePay} />}
			{paymentMethodsEnabled?.googlePayEnabled && (
				<FontAwesomeIcon
					icon={faGooglePay}
					color="#41474A"
				/>
			)}
			{paymentMethodsEnabled?.clearpayEnabled && (
				<SVG
					src={faClearpay}
					color="#060606"
				/>
			)}
			{paymentMethodsEnabled?.klarnaEnabled && <SVG src={faKlarna} />}
		</div>
	);
};

export default PaymentTypes;
